<template>

    <div class="page">
        <search ref="searchElement"></search>
        <shop-header
            @openSearch="openSearch"
        ></shop-header>
        <section class="content">
            <announcement
                v-for="announcement in announcements"
                :key="'announcement-' + announcement.uuid"
                :announcement="announcement.announcement"
            />
            <page-title
                :current-route="route().current()"
                :page="$page"
            ></page-title>
            <slot></slot>
        </section>
        <shop-footer></shop-footer>
        <flashmessages></flashmessages>
        <cookiewall></cookiewall>
    </div>

</template>

<script>

import Tracking from "./Tracking";
import PageTitle from "./PageTitle";
import ShopHeader from "./ShopHeader";
import ShopFooter from "./ShopFooter";
import Flashmessages from "./Flashmessages";
import Search from "./Search";
import Announcement from "./Announcement";
import Cookiewall from "./Cookiewall"

export default {

    computed: {
        announcements() {
            if (!this.$page.props.announcements) {
                return [];
            }

            return this.$page.props.announcements.data;
        }
    },

    components: {
        PageTitle,
        ShopHeader,
        ShopFooter,
        Flashmessages,
        Search,
        Announcement,
        Cookiewall,
    },

    extends: Tracking,

    methods: {
        openSearch() {
            this.$refs.searchElement.open();
        },
    },

    name:'Layout',

}

</script>
